export const westernAPIServer = process.env.VUE_APP_API_X_REGIS_WESTERN
export const nationAPIServer = process.env.VUE_APP_API_X_REGIS_NATION

export default {
  westernAPIServer,
  nationAPIServer,
}
